import { Product } from '@ridango/core';

export enum ProductType {
    WalletProduct = 'W'
}

export interface ProductsRequest { channel: string; isWalletType: boolean; }

export interface ProductNormalized { [id: string]: Product; }
